import { LockClosedIcon } from '@heroicons/react/24/outline';

function ToggleSwitch({ on }: { on: boolean }) {
    return (
        <span
            className={`w-8 h-[18px] rounded-full flex-shrink-0 relative transition-colors ${on ? 'bg-yellow-400' : 'bg-gray-400'}`}
        >
            <span
                className="absolute top-0.5 w-3.5 h-3.5 rounded-full bg-white shadow transition-all"
                style={{ left: on ? '16px' : '2px' }}
            />
        </span>
    );
}

function OrthopulseBadge({ mandatory }: { mandatory: boolean }) {
    return (
        <span
            className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${
                mandatory ? 'bg-yellow-400 text-gray-900' : 'bg-gray-100 text-gray-600'
            }`}
        >
            {mandatory ? 'Mandatory' : 'Recommended'}
        </span>
    );
}

interface OrthopulseToggleRowProps {
    on: boolean;
    isMandatory: boolean;
    isRecommended: boolean;
    disabled: boolean;
    onToggle: () => void;
}

export function OrthopulseToggleRow({
    on,
    isMandatory,
    isRecommended,
    disabled,
    onToggle
}: OrthopulseToggleRowProps) {
    return (
        <div>
            <div className="h-px bg-gray-200 mb-4" />
            <button
                type="button"
                role="switch"
                aria-checked={on}
                onClick={onToggle}
                disabled={isMandatory || disabled}
                className={`w-full flex items-center gap-3 px-3.5 py-3 rounded-lg border transition-colors text-left disabled:cursor-not-allowed ${
                    isMandatory || on
                        ? 'bg-yellow-50 border-yellow-400'
                        : 'bg-gray-50 border-gray-200 hover:border-gray-300'
                }`}
                style={{ borderWidth: '1.5px' }}
            >
                <ToggleSwitch on={on} />
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold text-gray-900">Add OrthoPulse</span>
                        {(isMandatory || isRecommended) && (
                            <OrthopulseBadge mandatory={isMandatory} />
                        )}
                        {isMandatory && (
                            <LockClosedIcon className="w-3 h-3 text-gray-500 flex-shrink-0" />
                        )}
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5">
                        Optimize bone metabolism for enhanced movement
                    </div>
                </div>
            </button>
        </div>
    );
}
